import { useEffect, useRef, useState } from "react";

/* eslint-disable react/prop-types */
const Countdown = ({ initialSeconds, onComplete }) => {
  const [seconds, setSeconds] = useState(initialSeconds);
  const hasCompletedRef = useRef(false);

  useEffect(() => {
    if (seconds <= 0) return;

    const timer = setInterval(() => {
      setSeconds((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [seconds]);

  useEffect(() => {
    if (seconds > 0 || hasCompletedRef.current) return;

    hasCompletedRef.current = true;
    onComplete?.();
  }, [seconds, onComplete]);

  // Formatear minutos:segundos
  const minutes = Math.floor(seconds / 60);
  const secs = seconds % 60;

  return (
    <div className="text-center text-2xl font-bold font-mono uppercase">
      {minutes}:{secs.toString().padStart(2, "0")}
    </div>
  );
};

export default Countdown;
